import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ApplicantType } from '@models/types/applicant_type';
import { OrgType } from '@models/types/org_type';
import { StatusType } from '@models/types/status_type';
import { AddressType } from '@models/types/address_type';
import { JobStatusType } from '@models/types/job_status_type';
import { DBAType } from '@models/types/dba_type';
import { EmailType } from '@models/types/email_type';
import { PhoneType } from '@models/types/phone_type';
import { ContactType } from '@models/types/contact_type';
import { environment } from '../../../environments/environment';
import 'rxjs/add/observable/forkJoin';
import { Observer } from 'rxjs';
@Injectable()
export class TypeService {

    constructor(private http: HttpClient) { }

    getAllTypes() {

        let refDataObservable = Observable.create((observer: Observer<any>) => {
            setTimeout(() => {
                observer.next("ApplicantType")
            }, 10
            )
            setTimeout(() => {
                observer.next("RelationType")
            }, 20
            )
            setTimeout(() => {
                observer.next("OrganizationType")
            }, 30
            )
            setTimeout(() => {
                observer.next("ContactType")
            }, 40
            )
            setTimeout(() => {
                observer.next("AddressType")
            }, 50
            )
            setTimeout(() => {
                observer.next("EmailType")
            }, 60
            )
            setTimeout(() => {
                observer.next("PhoneType")
            }, 70
            )
            setTimeout(() => {
                observer.next("ContacttoOppty")
            }, 80
            )
            setTimeout(() => {
                observer.next("ContacttoOrg")
            }, 90
            )
            setTimeout(() => {
                observer.next("OrgDesg")
            }, 100
            )
            setTimeout(() => {
                observer.next("OrgContact")
            }, 110
            )
            setTimeout(() => {
                observer.next("OrgOppty")
            }, 120
            )
            setTimeout(() => {
                observer.next("ReferedRelation")
            }, 130
            )
            setTimeout(() => {
                observer.next("VendorType")
            }, 140
            )
            setTimeout(() => {
                observer.next("VendorContact")
            }, 150
            )
            setTimeout(() => {
                observer.next("JobStatusType")
            }, 160
            )
        });
        refDataObservable.subscribe(data=>{
            if(data == 'ApplicantType'){
                this.getAplType();
            }else if(data == 'RelationType'){
                this.getRelType();
            }else if(data == 'OrganizationType'){
                this.getOrgType();
            }else if(data == 'ContactType'){
                this.getContactType();
            }else if(data == 'AddressType'){
                this.getAddType();
            }else if(data == 'EmailType'){
                this.geteMailType();
            }else if(data == 'PhoneType'){
                this.getPhoneType();
            }else if(data == 'ContacttoOppty'){
                this.contactToOpptyDesignation();
            }else if(data == 'ContacttoOrg'){
                this.contactToOrgDesignation();
            }else if(data == 'OrgDesg'){
                this.orgDesignation();
            }else if(data == 'OrgContact'){
                this.orgContactDesignation();
            }else if(data == 'OrgOppty'){
                this.orgOpptyDesignation();
            }else if(data == 'ReferedRelation'){
                this.referedRelation();
            }else if(data == 'VendorType'){
                this.getVendorType();
            }else if(data == 'VendorContact'){
                this.vendorContactDesignation();
            }else if(data == 'JobStatusType'){
                this.getJobStatus();
            }
        },
        error =>{

        })
        // this.getAplType();
        // this.getRelType();
        // this.getOrgType();
        // this.getContactType();
        // this.getAddType();
        // this.geteMailType();
        // this.getPhoneType();
        // this.contactToOpptyDesignation();
        // this.contactToOrgDesignation();
        // this.orgDesignation();
        // this.orgContactDesignation();
        // this.orgOpptyDesignation();
        // this.referedRelation();
        // this.getVendorType();
        // this.vendorContactDesignation();
    }

    getAplType() {
        this.http.get<ApplicantType>(`${environment.api}applicanttype`)
            .subscribe(res => {
                sessionStorage.setItem('applicanttype', JSON.stringify(res['data']));
                //
            }, err => {

            });
    }
    getRelType() {
        this.http.get<StatusType>(`${environment.api}statustype`)
            .subscribe(res => {
                sessionStorage.setItem('statustype', JSON.stringify(res['data']));

                //
            });
    }
    getOrgType() {
        this.http.get<ContactType>(`${environment.api}orgtype`)
            .subscribe(res => {
                sessionStorage.setItem('organizationtype', JSON.stringify(res['data']));
                //
            });
    }
    getContactType() {
        this.http.get<OrgType>(`${environment.api}contact_type`)
            .subscribe(res => {
                sessionStorage.setItem('contacttype', JSON.stringify(res['data']));
                //
            });
    }
    getVendorType() {
        this.http.get<OrgType>(`${environment.api}vendortype`)
            .subscribe(res => {
                sessionStorage.setItem('vendortype', JSON.stringify(res['data']));
                //
            });
    }
    getAddType() {
        this.http.get<AddressType>(`${environment.api}addresstype`)
            .subscribe(res => {
                sessionStorage.setItem('addresstype', JSON.stringify(res['data']));
                //
            });
    }
    geteMailType() {
        this.http.get<EmailType>(`${environment.api}emailtype`)
            .subscribe(res => {
                sessionStorage.setItem('emailtype', JSON.stringify(res['data']));
                //
            });
    }
    getPhoneType() {
        this.http.get<PhoneType>(`${environment.api}phonetype`)
            .subscribe(res => {
                sessionStorage.setItem('phonetype', JSON.stringify(res['data']));
                //
            });
    }
    contactToOpptyDesignation() {
         this.http.post(`${environment.api}designation/list`, { 'type': 'contact-oppty' })
            .subscribe(res => {
                sessionStorage.setItem('contactToOpptyDesg', JSON.stringify(res['data']));
            });
    }
    contactToOrgDesignation() {
         this.http.post(`${environment.api}designation/list`, { 'type': 'contact-org' })
            .subscribe(res => {
                sessionStorage.setItem('contactToOrgDesg', JSON.stringify(res['data']));
            });
    }
    orgDesignation() {
        this.http.post(`${environment.api}designation/list`, { 'type': 'organization' })
            .subscribe(res => {
                sessionStorage.setItem('orgDesg', JSON.stringify(res['data']));
            });
    }
    orgContactDesignation() {
        this.http.post(`${environment.api}designation/list`, { 'type': 'org-contact' })
            .subscribe(res => {
                sessionStorage.setItem('orgContactDesg', JSON.stringify(res['data']));
            });
    }
    orgOpptyDesignation() {
         this.http.post(`${environment.api}designation/list`, { 'type': 'org-oppty' })
            .subscribe(res => {
                sessionStorage.setItem('orgOpptyDesg', JSON.stringify(res['data']));
            });
    }

    referedRelation() {
         this.http.post(`${environment.api}designation/list`, { 'type': 'refered' })
            .subscribe(res => {
                sessionStorage.setItem('referedRelation', JSON.stringify(res['data']));
            });
    }

    vendorContactDesignation() {
        this.http.post(`${environment.api}designation/list`, { 'type': 'vendor-contact' })
            .subscribe(res => {
                sessionStorage.setItem('vendorContactDesg', JSON.stringify(res['data']));
            });
    }

    getJobStatus(){
        this.http.get<JobStatusType>(`${environment.api}job_status_type/1`)
            .subscribe(res => {
                sessionStorage.setItem('jobStatus', JSON.stringify(res['data']));
                //
            });
    }
    // return Observable.forkJoin([
    //     this.getAplType(),
    //     this.getRelType(),
    //     this.getOrgType(),
    //     this.getContactType(),
    //     this.getAddType(),
    //     this.geteMailType(),
    //     this.getPhoneType(),
    //     this.contactToOpptyDesignation(),
    //     this.contactToOrgDesignation(),
    //     this.orgDesignation(),
    //     this.orgContactDesignation(),
    //     this.orgOpptyDesignation(),
    //     this.referedRelation(),
    //     this.getVendorType(),
    //     this.vendorContactDesignation()
    // ]);
}



// WEBPACK FOOTER //
// ./src/app/shared/services/type.service.ts